import { FilterCompTypes } from 'app/ComponentLibrary/Filter/utils';
import { TaskFilterType } from 'app/models/Tasks/Tasks';
import { getTaskGridFilters } from 'app/services/TaskServices/TaskServices';

export enum taskFilterName {
  category = 'category',
  status = 'status',
  assignedTo = 'assignedTo',
  createdBy = 'createdBy',
}

const categoryOpts = ['Others', 'Missing RFO Requirements', 'Strike Clearance Requirements', 'Credentialing'];
const statusOpts = ['New', 'Pending', 'Completed', 'Cancelled'];
const assignedToOpts = ['Me'];

export const defaultTaskChips = {
  [taskFilterName.category]: [],
  [taskFilterName.assignedTo]: [{ label: 'Me', value: 'Me', enableDelete: false }],
  [taskFilterName.status]: [],
  [taskFilterName.createdBy]: [],
};

export const defaultTaskValue = {
  [taskFilterName.category]: [],
  [taskFilterName.assignedTo]: [{ id: 0, label: 'Me', value: 'Me' }],
  [taskFilterName.status]: [],
  [taskFilterName.createdBy]: [],
};

export const getFormattedTaskGridFilters = async (key, keyword?) => {
  const body = { filterTypeId: key, searchText: keyword };
  const data = await getTaskGridFilters(body);
  return data?.map(d => {
    return {
      value: d.value,
      name: key === TaskFilterType.CANDIDATE || key === TaskFilterType.FACILITY ? d.name + ', ' + d.value : d.name,
    };
  });
};

export const getTaskFilterSpecs = () => [
  {
    filterName: 'Task Category',
    name: taskFilterName.category,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(categoryOpts),
    isMultiSelect: true,
  },
  {
    filterName: 'Status',
    name: taskFilterName.status,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(statusOpts),
    isMultiSelect: true,
  },
  {
    filterName: 'Created By',
    name: taskFilterName.createdBy,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    isMultiSelect: true,
    fetchOptions: async keyword => await getFormattedTaskGridFilters(8, keyword),
  },
  {
    filterName: 'Assigned To',
    name: taskFilterName.assignedTo,
    type: FilterCompTypes.TYPEAHEADDROPDOWN,
    options: getOpts(assignedToOpts),
    isMultiSelect: true,
    isDisabled: true,
  },
];

const getOpts = options =>
  options.map((opt, i) => ({
    id: i,
    name: opt,
    value: opt,
  }));

export const TaskDefaultValues = {
  [taskFilterName.category]: [],
  [taskFilterName.status]: [],
  [taskFilterName.assignedTo]: [
    {
      id: 0,
      name: 'Me',
      value: 'Me',
    },
  ],
  [taskFilterName.createdBy]: [],
};
